export default {
  SET_DEFAULT_SETTINGS(state, default_settings) {
    state.default_settings = default_settings
  },
  ADD_EVENTS(state, events) {
    state.events = events
  },
  SET_SCHEDULE_AVALABILITY(state, schedule_avalability) {
    state.schedule_avalability = schedule_avalability
  },
  
}
